<template>
  <div>
    <v-dialog v-model="dialogVisible" width="fit-content">
      <v-card class="pdp-modal-container">
        <button class="btn-close" @click="closeModal">
          <v-icon class="icon-close">
            mdi-close
          </v-icon>
        </button>

        <div class="pdp-modal-content">
          <div
            v-if="!isLoading"
            v-html="staticPageDataHtml"
            class="html-content"
          ></div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'PDPModalVipWelcome',
  computed: {
    ...mapState({
      isLoading: state => state.staticPage.isLoading,
      staticPageDataHtml: state =>
        state.staticPage.data?.[0]?.html ?? '',
    }),
  },
  data() {
    return {
      dialogVisible: false,
    }
  },
  async mounted() {},
  methods: {
    openModal() {
      this.dialogVisible = true
    },
    closeModal() {
      this.dialogVisible = false
    },
  },
}
</script>

<style lang="stylus" scoped>
::v-deep .v-dialog {
    border-radius 18px
    border: 2px solid $color-bnn

    overflow-x hidden
    // max-height fit-content
    // overflow-y auto
    margin 20px 0 0

    @media screen and (min-width: 768px) {
        margin 0
    }

    @media screen and (min-width: 1024px) {
        margin 0
    }
}

.pdp-modal-container {
    margin 0 auto !important
    position relative

    width 100%
    max-width 90dvw
    min-width 90dvw
    position relative

    display flex
    flex-direction column

    @media screen and (min-width: 768px) {
        width 100%
        min-width 580px
        max-width 580px
    }

	.html-content {
		line-height: 0 !important;
	}

}

.pdp-modal-content {
    width 100%
    height fit-content
}

.footer-modal {
    display: flex
    justify-content: center
}

.btn-close {
	position: absolute;
	top: 12px;
	right: 12px;

    width: 40px;
    height: 40px;

    background: #e8e8e8;
    border-radius: 50% !important;

    z-index 10

    &:hover {
        .icon-close {
            color: rgba(0,0,0,0.72)
        }
    }

    &:focus {
        outline: .125rem solid $color-bnn;
        outline-offset: .125rem;
        outline-offset: .125rem;
    }

    .icon-close {
        color: rgba(18,18,18,0.56)
    }

	@media screen and (min-width: 768px) {
		top: 20px;
		right: 20px;
	}
}
</style>
